module.exports = __webpack_public_path__ + "img/klarna-rechnung.9033f795.png";